import { PetalsTabController } from '../PetalsTabController';
import { ComponentPanelController } from '../ComponentPanelController'
import { PropertiesPanelController } from '../PropertiesPanelController'
import { Entity } from '@rhinov/savane-js';

export class TulipPanelWidget {

    tulipModal: PetalsTabController;
    id: string;
    parent: HTMLElement;
    controller: ComponentPanelController | PropertiesPanelController | null = null;

    closetab = () => {
        this.destroy();
        this.tulipModal.openedPanel = null;
    }

    destroy = () => {
        let closebtn = document.getElementById('closeTulipPanel');
        if (closebtn) {
            closebtn.removeEventListener('click', this.closetab);
        }
        if (this.controller) {
            this.controller.destroy();
            this.controller = null;
        }
        this.parent.innerHTML = "";
    }

    constructor (tulipModal: PetalsTabController) {
        this.tulipModal = tulipModal;
        this.id = tulipModal.openedPanel === 'COMPONENT_PANEL' ? 'component-panel' : "properties-panel";
        this.parent = document.getElementById(this.id) as HTMLElement;
        if (!parent) return;
        this.parent.classList.add('hide');
        this.parent.innerHTML = this.html();
        setTimeout(() => {
            switch(this.tulipModal.openedPanel) 
            {
            case 'COMPONENT_PANEL':        
                this.controller = new ComponentPanelController(this.tulipModal.tulipItem as Entity, this.tulipModal.panelConf);
                break;
            case 'PROPERTIES_PANEL':
                this.controller = new PropertiesPanelController(this.tulipModal.tulipItem as Entity, this.tulipModal.panel, this.tulipModal.deliverable, this.tulipModal.designer, this.tulipModal.openAssetDetailCallback, this.tulipModal.user);
                break;
            }
            let closebtn = document.getElementById('closeTulipPanel');
            if (closebtn) {
                closebtn.addEventListener('click', this.closetab);
            }
        }, 200);
    }

   

    html(): string {
        if (this.tulipModal.openedPanel === 'COMPONENT_PANEL') {
            return `
            <div id="componentPanel" class="menu-tulip panel-properties"
            style="z-index: 3002;display:block;">
                <div id="panelCompMovable" class="compDiv"
                style="position: fixed;align-items:flex-start;height:fit-content;max-height:650px;width:fit-content; max-width:600px">
                    <div style="display:block;text-align:left;width:100%;">
                    Détails
                    </div>
                    <button id="closeTulipPanel" style="position:absolute;right:6px;top:6px" class="btn-flat btn btn-info-inverted pull-right borderless">
                        <span class="material-icons icon-Close"></span>
                    </button>
                    <div id="innerPanelContainer" style="display: flex;flex-direction:column; overflow-y:auto; margin-top:20px"></div>
                </div>
            </div>
            `;        
        }
        if (this.tulipModal.openedPanel === 'PROPERTIES_PANEL') {
            return `
                <div id="propertiesPanel" class="menu-tulip panel-properties" style="position:relative;">
                    <div id="panelPropMovable" style="position:fixed;width:fit-content;max-height:900px;flex-wrap:wrap;flex-direction:column">
                        <button id="closeTulipPanel" style="position:absolute;right:6px;top:6px;z-index:100" type="button" class="btn-flat btn btn-info-inverted pull-right borderless">
                            <span class="material-icons icon-Close"></span>
                        </button>
                    </div>
                </div>
            `;
        }
        return "";
    }
}
